import { Components } from "@mui/material/styles/components";

export const MuiIconButton: Components["MuiIconButton"] = {
  styleOverrides: {
    root: {
      width: "40px",
      height: "40px",
      border: `1px solid #CDD1E0`,
    },
  },
};
